import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IChienDichActionTypes } from "../../action-types/crm-survey/IChienDichActionTypes";
import { IChienDichReducer } from "../../page-state-model/crm-survey/IChienDichReducer";
const iniState: IChienDichReducer = {
    status: ePageBaseStatus.is_not_initialization,
    chienDichs: [],
    chienDichVms: []
}
export const chienDichReducer = (state: IChienDichReducer = iniState, action: IChienDichActionTypes): IChienDichReducer => {
    switch (action.type) {
        case "CHIEN_DICH_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CHIEN_DICH_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                chienDichVms: action.payload
            }
        case "CHIEN_DICH_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                chienDichVms: []
            }
        case "CHIEN_DICH_LOAD_COSO_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CHIEN_DICH_LOAD_COSO_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                chienDichVms: action.payload
            }
        case "CHIEN_DICH_LOAD_COSO_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                chienDichVms: []
            }
        case "CHIEN_DICH_LOAD_TRUONG_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CHIEN_DICH_LOAD_TRUONG_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                chienDichs: action.payload
            }
        case "CHIEN_DICH_LOAD_TRUONG_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                chienDichs: []
            }
        case "CHIEN_DICH_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "CHIEN_DICH_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "CHIEN_DICH_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "CHIEN_DICH_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "CHIEN_DICH_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "CHIEN_DICH_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "CHIEN_DICH_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "CHIEN_DICH_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }

        case "CHIEN_DICH_LOCK_START":
            return {
                ...state,
                status: ePageBaseStatus.is_locking
            }
        case "CHIEN_DICH_LOCK_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "CHIEN_DICH_LOCK_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "CHIEN_DICH_UNLOCK_START":
            return {
                ...state,
                status: ePageBaseStatus.is_unlocking
            }
        case "CHIEN_DICH_UNLOCK_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "CHIEN_DICH_UNLOCK_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}